@use '../../../scss/utility';
@use 'tab-vars';

:host {
  @include tab-vars.wb-tab-vars;

  background-color: var(--tab-background-color);
  border: var(--tab-border);
  outline: none;

  // component styles
  display: block;
  cursor: pointer;
  min-width: utility.wb-pixel-to-rem(80px);
  width: auto; // very important, otherwise text doesn't take up the correct width
  color: var(--tab-text-color);
  text-align: center;
  white-space: nowrap; // keeps tab text on a single line
  padding: var(--tab-padding); // same as tertiary button, medium size
}

:host(:hover:not([disabled])) {
  @include tab-vars.wb-tab-hover-vars;
  transition: background-color 0.3s ease-in-out;
}

.text {
  display: flex;
  align-items: center;
  justify-content: center;
}

::slotted(.wb-icon) {
  flex-shrink: 0;
  --size: var(--tab-icon-size);
  color: var(--tab-icon-color);
}

:host(:focus) {
  @include tab-vars.wb-tab-focus-vars;
}

:host([disabled]) {
  opacity: 0.4;
  cursor: not-allowed;
}

:host([icon-only]) {
  @include tab-vars.wb-tab-icon-only-vars;

  .wb-text {
    font-size: 0;
  }
}

:host([icon-only]:hover:not([disabled])) {
  @include tab-vars.wb-tab-icon-only-hover-vars;
}

:host([icon-only]:focus) {
  @include tab-vars.wb-tab-icon-only-hover-vars;
}

:host([selected]) {
  @include tab-vars.wb-tab-selected-vars;
}

:host([selected]:hover:not([disabled])) {
  @include tab-vars.wb-tab-selected-hover-vars;
}

:host([selected]:active:not([disabled])) {
  @include tab-vars.wb-tab-selected-active-vars;
}

:host([selected]:focus) {
  @include tab-vars.wb-tab-selected-focus-vars;
}

:host([selected][icon-only]) {
  @include tab-vars.wb-tab-icon-only-selected-vars;
}

:host([selected][icon-only]:hover:not([disabled])) {
  @include tab-vars.wb-tab-icon-only-selected-hover-vars;
}

:host([selected][icon-only]:focus) {
  @include tab-vars.wb-tab-icon-only-selected-focus-vars;
}
